import { Client } from './client';
import { ClientTenant } from './client-tenant';
import { Feature } from './feature';

export class User {
    UserId: number;
    UserName: string;
    EmailAddress: string;
    IsRegistered: boolean;
    IsActive: boolean;
    Clients: Client[];
    ClientTenants: ClientTenant[];
    Features: Feature[];
    UserProfileSettings: string;
}
